import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=3faed13a&scoped=true"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderDropdownAccnt.vue?vue&type=style&index=0&id=3faed13a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faed13a"]])

export default __exports__